<div [innerHTML]="html | stripTagsExcept : ['text-formatting-tags', 'structural-tags', 'link-tags']"></div>
